import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'SUBSTITUTE',
  category: FunctionCategory.TEXT,
  description: 'Replaces existing text from each value in a column or a single string with new text.',
  shortDescription: 'Replaces existing text with new text',
  params: [
    {
      name: 'text_to_search',
      type: ArgType.text,
      description: 'Either a column or string, the text within which to search and replace.',
    },
    {
      name: 'old_text',
      type: ArgType.text,
      description:
        'Either a column or string, the string to search for within text_to_search. All occurrences will be replaced with new_text.',
    },
    {
      name: 'new_text',
      type: ArgType.text,
      description: 'Either a column or string, the string that will replaced old_text.',
    },
  ],
} satisfies AnalysisFunction;
